import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checkboxes-wrapper checkboxes-wrapper--airport" }
const _hoisted_2 = { class: "p-field-checkbox" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "hasTransfer" }, "Трансфер из аэропорта", -1)
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "hasFitness" }, "Фитнес", -1)
const _hoisted_6 = { class: "p-field-checkbox" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "hasInternet" }, "Интернет", -1)
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "hasParking" }, "Парковка", -1)
const _hoisted_10 = { class: "p-field-checkbox" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "hasPool" }, "Бассейн", -1)
const _hoisted_12 = { class: "p-field-checkbox" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "hasSpa" }, "СПА", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Checkbox, {
        id: "hasTransfer",
        name: "hasTransfer",
        value: "hasAirportTransfer",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.services = $event)),
        onChange: _cache[2] || (_cache[2] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Checkbox, {
        id: "hasFitness",
        name: "hasFitness",
        value: "hasFitness",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.services = $event)),
        onChange: _cache[4] || (_cache[4] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Checkbox, {
        id: "hasInternet",
        name: "hasInternet",
        value: "hasInternet",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.services = $event)),
        onChange: _cache[6] || (_cache[6] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Checkbox, {
        id: "hasParking",
        name: "hasParking",
        value: "hasParking",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.services = $event)),
        onChange: _cache[8] || (_cache[8] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_9
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_Checkbox, {
        id: "hasPool",
        name: "hasPool",
        value: "hasPool",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.services = $event)),
        onChange: _cache[10] || (_cache[10] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_11
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_Checkbox, {
        id: "hasSpa",
        name: "hasSpa",
        value: "hasSpa",
        modelValue: _ctx.services,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.services = $event)),
        onChange: _cache[12] || (_cache[12] = $event => (_ctx.filterByServices(_ctx.services)))
      }, null, 8, ["modelValue"]),
      _hoisted_13
    ])
  ]))
}